import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouteReuseStrategy } from '@angular/router';

//import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { IonicStorageModule } from '@ionic/storage';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { PopoverComponent } from './pages/main/tabs/popover/popover.component';

import { DataAccessService } from './services/data-access.service';
import { GlobalIntervalService } from './services/global-interval-service.service';
import { StatsService } from './services/stats-service.service';

import { SharedModule } from './components/shared.module';

import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';

import { Camera } from '@ionic-native/camera/ngx';
import { CameraPreview, CameraPreviewPictureOptions, CameraPreviewOptions, CameraPreviewDimensions } from '@ionic-native/camera-preview/ngx';
import { OCR } from '@ionic-native/ocr/ngx';

import { File } from '@ionic-native/file/ngx';
import { Printer } from '@ionic-native/printer/ngx';
import { Clipboard } from '@ionic-native/clipboard/ngx';
import { FileTransfer } from '@ionic-native/file-transfer/ngx';
import { PermissionService } from './services/permission-service.service';
import { TranslationService } from './services/translation-service.service';
import { InterceptorService } from './services/interceptor-service.service';
import { LockService } from './services/lock-service.service';



@NgModule({
    declarations: [AppComponent, PopoverComponent],
    entryComponents: [PopoverComponent],
    imports: [
        BrowserModule,
        HttpClientModule,
        IonicModule.forRoot(),
        AppRoutingModule,
        IonicStorageModule.forRoot(),
        SharedModule,
        //BrowserAnimationsModule,
    ],
    providers: [
        StatusBar,
        SplashScreen,
        DataAccessService,
        GlobalIntervalService,
        LockService,
        { provide: StatsService, useClass: StatsService, deps: [GlobalIntervalService, DataAccessService] },
        PermissionService,
        { provide: TranslationService, useClass: TranslationService, deps: [GlobalIntervalService] },
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true, deps: [StatsService] },
        BarcodeScanner,
        Camera,
        CameraPreview,
        OCR,
        File,
        Printer,
        Clipboard,
        FileTransfer
    ],
    exports: [SharedModule],
    bootstrap: [AppComponent]
})
export class AppModule { }
